/**
 * Shared C2PA SDK configuration.
 *
 * Mirrors verifieddit-www so the two sites cannot drift on WASM version or
 * trust anchors. The browser does all C2PA reading and integrity validation
 * locally — asset bytes never leave the device. Only the extracted manifest
 * metadata is sent onward.
 *
 * IMPORTANT: public/c2pa.wasm MUST be the exact binary shipped by the installed
 * @contentauth/c2pa-web version. Re-sync with `bun run sync-wasm` whenever the
 * SDK is upgraded, and bump C2PA_WASM_VERSION to bust the cache.
 */

/** Cache-buster — bump when public/c2pa.wasm changes (synced from @contentauth/c2pa-web@0.12.4). */
const C2PA_WASM_VERSION = '0.12.4-1'

/** Cache-buster — bump when public/c2pa-trust-list.pem changes. */
const TRUST_LIST_VERSION = '2'

/** The SPA is served under /drop, so WASM and trust list live under that base. */
export const C2PA_WASM_URL = `/drop/c2pa.wasm?v=${C2PA_WASM_VERSION}`

/** Absolute trust-anchors URL (the SDK fetches it, so it needs an "http" prefix). */
export const c2paTrustAnchorsUrl = () =>
  `${location.origin}/drop/c2pa-trust-list.pem?v=${TRUST_LIST_VERSION}`
